function linkEvent(sampleTab) {
    const detailsElement = sampleTab.querySelector('details');
    const summaryElement = sampleTab.querySelector('summary');

    if (!detailsElement || !summaryElement) return null;

    if (detailsElement.getAttribute('open') !== 'true') {
        detailsElement.setAttribute('open', 'true');
        summaryElement.setAttribute('aria-expanded', 'true');
        return;
    }

    detailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', 'false');
}

function init() {
    const sampleLink = document.querySelector('[href="#samples"]');
    const sampleTab = document.querySelector('.product__accordion--samples');

    if (!sampleLink || !sampleTab) return null;
    sampleLink.addEventListener('click', () => linkEvent(sampleTab));
}

document.addEventListener('DOMContentLoaded', init);
